export enum Alerts {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    SEARCH_SCENARIO_APPROXIMATE = "No match found, showing the caller's approximate location.",
    SEARCH_SCENARIO_HOME_ADDRESS = "The lat/long matches the caller's home address.",
    SEARCH_SCENARIO_ASSOCIATE_ADDRESS = "The lat/long matches the address of an associate or relative of the caller."
}
